import styled, { css } from 'styled-components';
import { Image } from '../../image';
import { pxToRem } from '../../../design-tokens/style-utilities';
const SLIDE_SPEED = '0.5s';
export const gallerySlideStyles = ({ theme, $variant, }) => css `
	grid-area: slide;
	align-self: center;
	overflow: hidden;
	border-radius: ${pxToRem(theme.borderRadius.m)};
	margin: 0;
	display: block;

	${$variant === 'video' &&
    css `
		position: relative;
	`}

	figure,
	${Image}, img {
		height: 100%;
		margin: 0;
		user-select: none;
	}

	img {
		object-fit: contain;
	}
`;
export const GallerySlide = styled.div `
	${gallerySlideStyles}
`;
/**
 * Gallery slide animation
 */
export const gallerySlideAnimationStyles = () => css `
	height: 100%;
	width: 100%;
	margin: 0;
	transition: margin-left ${SLIDE_SPEED};
	border-radius: 0;
	overflow: hidden;
`;
export const GallerySlideAnimation = styled.figure `
	${gallerySlideAnimationStyles}
`;
/**
 * Gallery image slide interactive
 */
export const gallerySlideImageStyles = ({ $isGrabbing, $isGrabbable, }) => css `
	${$isGrabbing &&
    css `
		cursor: grabbing;
	`}

	${$isGrabbable &&
    css `
		cursor: grab;
	`}
`;
export const GallerySlideImage = styled(Image) `
	${gallerySlideImageStyles}
`;
